import styled from 'styled-components';

import { colors } from '../../styles/colors';

function checkboxColor(checked: boolean | undefined, disabled: boolean | undefined, uncheckedColor: string): string {
  if (!checked) return uncheckedColor;
  return disabled ? colors.Grey300 : colors.brand.principal;
}

export const Base = styled.div<{ checked?: boolean, disabled?: boolean, size?: number }>`
  align-items: center;
  background-color: ${({ checked, disabled }) => checkboxColor(checked, disabled, colors.White)};
  border: 1px solid ${({ checked, disabled }) => checkboxColor(checked, disabled, colors.Grey)};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  width: ${({ size }) => (!size ? '25px;' : `${size}px`)};
  height: ${({ size }) => (!size ? '25px;' : `${size}px`)};
  min-width: ${({ size }) => (!size ? '25px;' : `${size}px`)};
  min-height: ${({ size }) => (!size ? '25px;' : `${size}px`)};
`;

export const Label = styled.label`
  cursor: pointer;
  display: flex;
  color: ${colors.Grey400};
`;
